import { render, staticRenderFns } from "./DetallePreventivaForm.vue?vue&type=template&id=47777440&scoped=true&"
import script from "./DetallePreventivaForm.vue?vue&type=script&lang=ts&"
export * from "./DetallePreventivaForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetallePreventivaForm.vue?vue&type=style&index=0&id=47777440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47777440",
  null
  
)

export default component.exports